export default "__VITE_ASSET__CHjryPjd__"